// src/components/WelcomeCarousel.js
import { Box, Typography, Button, Card, CardContent } from '@mui/material';

const WelcomeCarousel = () => {
  return (
    <Box sx={{display: 'flex', justifyContent: 'center', m: 'auto', maxWidth: 380}}>
      <Card variant="transparent" sx={{textAlign: 'left'}}>
        <Typography variant="h2" component="h2" gutterBottom>
          Encontre tudo para seu pet, aqui em Curitiba e Região!
        </Typography>

        <Typography variant="body1" component="small" sx={{ mb: 2 }}>
          Cadastre seus pets e encontre os melhores preços com nossa busca inteligente!
        </Typography>
      </Card>
    </Box>
  );
};

export default WelcomeCarousel;